import * as api from '../../../../common/api';
import * as validators from '../../../../common/validators';

export function changeNewsletterEmail(payload) {
  return {
    type: 'CHANGE_NEWSLETTER_EMAIL',
    payload
  };
}

export function validateField(name, value) {
  return (dispatch) => {
    const validations = {
      email: [validators.isRequired, validators.isEmail]
    };

    const errors = validations[name].reduce(
      (acc, validator) => {
        const result = validator(value);

        if (result) { acc.push(result); }

        return acc;
      },
      []
    );

    return dispatch({
      type: 'SET_FIELD_ERROR',
      payload: { name, errors }
    });
  };
}

export function submitForm() {
  return (dispatch, getState) => {
    const { email } = getState().newsletter;

    const promise = async () => {
      const response = await api.post('/newsletter_user', { email });

      return response.status === 204;
    };

    return dispatch({
      type: 'SUBMIT_NEWSLETTER_FORM',
      payload: promise()
    }).catch(() => null);
  };
}



// WEBPACK FOOTER //
// ./src/browser/Feature/components/newsletter_form/actions.js